import React from "react";
import { Link } from "react-router-dom";
import { FileText, ExternalLink, ArrowRight } from "lucide-react";
import WHITE_PAPERS from "../data/whitePaperArticles";

export default function WhitePapers() {
  return (
    <div>
      <section className="bg-[#f4f5f7] py-14 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <h1 className="text-4xl font-semibold text-slate-800">White Papers</h1>
          <p className="mt-3 text-slate-600 max-w-2xl">
            Technical articles and knowledge-base posts covering NFC tag technologies, reader development, and
            real-world integration patterns.
          </p>
        </div>
      </section>

      <div className="max-w-5xl mx-auto px-6 lg:px-10 py-14">
        <ul className="space-y-5">
          {WHITE_PAPERS.map((p) => (
            <WhitePaperCard key={p.title} paper={p} />
          ))}
        </ul>
      </div>
    </div>
  );
}

function WhitePaperCard({ paper }) {
  const cardClasses =
    "group flex gap-5 bg-white border border-slate-200 rounded-md p-6 hover:border-[#29abe2] hover:shadow-md transition-all";

  const body = (
    <>
      <div className="w-12 h-12 rounded-full bg-[#29abe2]/10 flex items-center justify-center flex-shrink-0 group-hover:bg-[#29abe2]/20 transition-colors">
        <FileText className="w-5 h-5 text-[#29abe2]" />
      </div>
      <div className="flex-1 min-w-0">
        <h2 className="text-lg md:text-xl font-semibold text-slate-800 group-hover:text-[#29abe2] transition-colors uppercase tracking-wide">
          {paper.title}
        </h2>
        {paper.date && <div className="mt-1 text-xs text-slate-500">{paper.date}</div>}
        <p className="mt-3 text-slate-600 leading-relaxed text-[15px]">{paper.summary}</p>
        <div className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#29abe2]">
          Read more
          {paper.internal ? (
            <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
          ) : (
            <ExternalLink className="w-3.5 h-3.5" />
          )}
        </div>
      </div>
    </>
  );

  if (paper.internal) {
    return (
      <li>
        <Link to={paper.url} className={cardClasses}>
          {body}
        </Link>
      </li>
    );
  }

  return (
    <li>
      <a href={paper.url} target="_blank" rel="noopener noreferrer" className={cardClasses}>
        {body}
      </a>
    </li>
  );
}
